const LEAVES = [
  [60, 300, 34], [110, 282, 40], [165, 300, 34], [40, 335, 26], [190, 336, 28], [85, 252, 28],
  [140, 248, 30], [72, 330, 24], [150, 330, 26], [112, 318, 28], [28, 300, 20], [205, 300, 20],
];

export const Baobab = ({ vitality = 0.3, grow = false, scale = 1 }) => {
  const shown = Math.round(4 + vitality * (LEAVES.length - 4));
  return (
    <g transform={`scale(${scale})`}>
      <path d="M92 470 C98 420 96 380 88 340 L136 340 C128 380 126 420 132 470 Z" fill="#6B4F3A" />
      <path d="M100 470 C104 425 103 385 98 345" stroke="#57402F" strokeWidth="5" fill="none" />
      <path d="M95 345 C80 320 60 310 40 305 M110 342 C108 310 112 280 112 262 M130 345 C150 320 175 312 198 304 M120 342 C135 318 140 290 142 258"
        stroke="#6B4F3A" strokeWidth="9" strokeLinecap="round" fill="none" />
      {LEAVES.map(([x, y, r], i) => (
        <circle key={i} cx={x} cy={y} r={r}
          className={grow && i === shown - 1 ? "leaf-grow" : ""}
          fill={i < shown ? (i % 2 ? "#17A2A2" : "#2BA36B") : "#C9B48A"}
          opacity={i < shown ? 0.92 : 0.35} />
      ))}
    </g>
  );
};

export const VillageScene = ({ vitality = 0.2, mission }) => (
  <div className="absolute inset-0" aria-hidden data-testid="village-scene">
    <img decoding="async" src="/assets/village_bg.webp" srcSet="/assets/village_bg-sm.webp 424w, /assets/village_bg.webp 848w" sizes="(max-width: 480px) 100vw, 480px" alt="" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
    <img decoding="async" src="/assets/village_bg_revived.webp" srcSet="/assets/village_bg_revived-sm.webp 424w, /assets/village_bg_revived.webp 848w" sizes="(max-width: 480px) 100vw, 480px" alt="" className="absolute inset-0 h-full w-full object-cover transition-opacity duration-[1500ms]"
      style={{ opacity: Math.max(0, Math.min(1, vitality)) }} draggable={false} />
    <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/25 to-transparent" />
  </div>
);
